import { BodilColor } from '~src/branding';

import { InfoBoxType } from './types';

export const infoBoxColorAndSize = (color?: string, type: InfoBoxType = 'default') => {
  switch (type) {
    case 'frontend':
      return {};

    case 'default':
      return {
        backgroundColor: color ?? undefined,
        textColor: BodilColor.greyscale['00'],
        headerSize: 16,
        textSize: 24,
      };
  }
};
